import React from 'react';

/* Skeleton de carregamento — sempre na cor paper-alt, discreto */
const Skeleton = ({ className }) => (
  <div className={`animate-pulse bg-paper-alt rounded ${className}`}></div>
);

export const DashboardSkeleton = () => (
  <div className="space-y-8 animate-pulse">
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      {[1, 2, 3, 4].map(i => <div key={i} className="h-24 bg-paper-alt rounded-card"></div>)}
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div className="lg:col-span-2 h-64 bg-paper-alt rounded-card"></div>
      <div className="h-64 bg-paper-alt rounded-card"></div>
    </div>
  </div>
);

export const TableSkeleton = () => (
  <div className="space-y-4">
    {[1, 2, 3, 4, 5].map(i => (
      <div key={i} className="flex items-center space-x-4 p-4 border-b border-line">
        <Skeleton className="h-10 w-10 rounded-full" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-1/4" />
          <Skeleton className="h-3 w-1/2" />
        </div>
        <Skeleton className="h-8 w-20" />
      </div>
    ))}
  </div>
);

export default Skeleton;
